<app-cart-table-row class="uk-card uk-card-small uk-card-default uk-card-body uk-margin-small-bottom" *ngFor="let item of cart.content.items" [item]="item"></app-cart-table-row>
